import { twMerge } from "tailwind-merge";
import { PropsWithAs } from "../types";
import { ForwardedRef } from "react";
import { forwardRefWithGeneric } from "../utils";

export interface CardFooterProps {}

const CardFooter = <T extends React.ElementType = "div">(
  { as, ...props }: PropsWithAs<CardFooterProps, T>,
  ref: ForwardedRef<any>
) => {
  const { className, ...rest } = props;
  const Component = as ?? "div";

  return (
    <Component
      {...rest}
      ref={ref}
      className={twMerge("p-4 font-light flex gap-2", className)}
    />
  );
};

export default forwardRefWithGeneric(CardFooter);
